import { useTheme, Box } from '@mui/material';
import BackpackBaggageColor from '@shared/assets/BackpackBaggageColor';
import BaggageHandColor from '@shared/assets/BaggageHandColor';
import BaggageHoldColor from '@shared/assets/BaggageHoldColor';

const RenderBaggageIcons = ({
  baggage,
  transform = { xs: 'scale(1)', lg: 'scale(0.8)' },
  transformOrigin = 'bottom',
  mt = 0,
}) => {
  const theme = useTheme();
  if (!baggage) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        gap: { xs: '4px', sm: 1, lg: '4px' },
        flexShrink: 0,
        transform,
        transformOrigin,
        mt,
      }}
    >
      <Box sx={{ height: 49, display: 'flex', alignItems: 'flex-end' }}>
        <BackpackBaggageColor
          color={baggage.backpack_baggage ? theme.tertiary : undefined}
        />
      </Box>

      <Box sx={{ height: 49, display: 'flex', alignItems: 'flex-end' }}>
        <BaggageHandColor
          color={baggage.hand_baggage ? theme.tertiary : undefined}
        />
      </Box>

      <Box sx={{ height: 49, display: 'flex', alignItems: 'flex-end' }}>
        <BaggageHoldColor
          color={baggage.baggage_hold ? theme.tertiary : undefined}
        />
      </Box>
    </Box>
  );
};

export default RenderBaggageIcons;
